import * as Actions from '../../../Modules/CmsActions'
import type { Taxonomy } from '../../../Types'

interface IUITaxonomyState {
  loading: boolean
  currentTaxonomy: Taxonomy | null
  terms: any[]
  edit: {
    id: number
    name: string
    slug: string
    taxonomy_id: number
    fields: {
      [key: string]:
        | string
        | number
        | boolean
        | number[]
        | {
            file_name: string
            image_url: string
            public_image_url: string
          }
    }
    seo_setting: {
      id: number
      seo_title: string
      seo_title_for_search: string
      seo_title_for_pagination: string
      seo_description: string
      script_embedding_type: string
      before_head_close_tag: string
      after_body_open_tag: string
      before_body_close_tag: string
      cookie_before_head_close_tag: string
      cookie_after_body_open_tag: string
      cookie_before_body_close_tag: string
      canonical_url: string
      is_noindex: boolean
      is_nofollow: boolean
      is_show_sitemap: boolean
      structured_data: string
      og_title: string
      og_title_for_search: string
      og_title_for_pagination: string
      og_description: string
      og_image_url: string
      twitter_og_title: string
      twitter_og_title_for_search: string
      twitter_og_title_for_pagination: string
      twitter_og_description: string
      twitter_og_image_url: string
    }
  }
  conditions: { name: string | null }
  saving: boolean
}

const initialState: IUITaxonomyState = {
  loading: true,
  currentTaxonomy: null,
  terms: [],
  edit: {
    id: 0,
    name: '',
    slug: '',
    taxonomy_id: 0,
    fields: {},
    seo_setting: {
      id: 0,
      seo_title: '',
      seo_title_for_search: '',
      seo_title_for_pagination: '',
      seo_description: '',
      script_embedding_type: 'postscript',
      before_head_close_tag: '',
      after_body_open_tag: '',
      before_body_close_tag: '',
      cookie_before_head_close_tag: '',
      cookie_after_body_open_tag: '',
      cookie_before_body_close_tag: '',
      canonical_url: '',
      is_noindex: false,
      is_nofollow: false,
      is_show_sitemap: true,
      structured_data: '',
      og_title: '',
      og_title_for_search: '',
      og_title_for_pagination: '',
      og_description: '',
      og_image_url: '',
      twitter_og_title: '',
      twitter_og_title_for_search: '',
      twitter_og_title_for_pagination: '',
      twitter_og_description: '',
      twitter_og_image_url: '',
    },
  },
  conditions: {
    name: null,
  },
  saving: false,
}

const UITaxonomyReducer = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case Actions.REQUEST_SEARCH_TAXONOMY:
      return {
        ...state,
        currentTaxonomy: payload.taxonomy,
        loading: true,
      }

    case Actions.FINISH_SEARCH_TAXONOMY:
      return {
        ...state,
        terms: payload.terms,
        loading: false,
      }

    case Actions.UNLOAD_TERM:
      return { ...state, edit: initialState.edit }

    case Actions.REQUEST_CREATE_TERM:
    case Actions.REQUEST_UPDATE_TERM:
      return { ...state, saving: true }

    case Actions.FINISH_CREATE_TERM:
    case Actions.FINISH_UPDATE_TERM:
      return { ...state, saving: false }

    case Actions.REQUEST_FIND_TERM:
    case Actions.REQUEST_DELETE_TERM:
    case Actions.REQUEST_SORT_TERM:
      return { ...state, loading: true }

    case Actions.FINISH_DELETE_TERM:
    case Actions.FINISH_SORT_TERM:
      return { ...state, loading: false }

    case Actions.FINISH_FIND_TERM:
      return {
        ...state,
        edit: payload.term
          ? {
              ...payload.term,
              seo_setting:
                payload.term.seo_setting || initialState.edit.seo_setting,
            }
          : initialState.edit,
        loading: false,
      }

    case Actions.REQUEST_CHANGE_CONDITION_TERMS:
      return updateCondition(state, action.payload.text)

    default:
      return state
  }
}

const updateCondition = (state, value) => {
  return {
    ...state,
    conditions: {
      name: value,
    },
  }
}

export default UITaxonomyReducer
